import { CaseType } from "src/types/case";

export type CaseListingType = CaseType & {
  id: number;
  investigated_at: string | null;
  drug_name:string;
  color_idx: 1 | 2 | 3 | 4 | 5;
  status_name: string;
  created_at: string | null;
  active_precert: boolean;
  active_precert_id: number | null;
  appeal_precert_id: number | null;
  pending_precert_id: number | null;
  precert_maximum: boolean;
  precert_minimum: boolean;
  cancelled_state: boolean;
  prescription_id: number;
  ongoing: string;
  treated: string;
  next_eligible_tmnt: string;
  next_step: string[];
  re_run_type:string;
  pa_workflow_required: boolean;
  patient: {
    id: number;
    external_id: string;
    firstlastname: string;
    global_patient_id: number;
  };
  doctor: {
    id: number;
    firstlastname: string;
  };
  treatment?: {
    id: number;
    scheduled_at: string | null;
  };
   kam_fam_notes: {
    text: "";
    clickable: false;
    type: string;
  };
  practice_fax_number: number;
  practice_full_address: string;
  practice_name: string;
  practice_phone_number: number;
};

export type CaseListErrorResponse = {
  code: number;
  error: string;
};

export type caseListAPIResponse = {
  code: number;
  message: string;
  data: {
    case: CaseType[];
  };
};

export type CaseListAPIResponseType = {
  status: number;
  cases: CaseListingType[];
  total_pages: number;
  investigated: number;
  pending: number;
  practice_dropdown: { id: number; name: string }[];
  doctor_dropdown: { id: number; name: string }[];
};

export type QueryParamsState = {
  open: string | boolean;
  sort_by: string;
  direction: "asc" | "desc";
  search_query: string;
  date_from: string;
  date_to: string;
  page: number;
  practice_id: string;
  global_doctor_id: string;

};

export enum QueryStateActions {
  CHANGE_CASE_STATUS = "changeCaseStatus",
  CHANGE_SORT_PARAMS = "changeSortParams",
  CHANGE_SEARCH_QUERY = "changeSearchQuery",
  CHANGE_FROM_DATE = "changeFromDate",
  CHANGE_TO_DATE = "changeToDate",
  CLEAR_STATE = "clearState",
  CHANGE_PAGE = "changePage",
  CHANGE_PRACTICE_ID = "changePracticeId",
  CHANGE_QUERY_PARAMS = "changeQueryParams",
  CHANGE_GLOBAL_DOCTOR_ID = "changeGlobalDoctorId",
  SET_FILTERS = "setFilters"

}

export type QueryStateActionType =
  
| {
    type: QueryStateActions.CHANGE_QUERY_PARAMS;
    payload: Partial<QueryParamsState>;
  }| {
      type: QueryStateActions.CHANGE_CASE_STATUS;
      payload: boolean | string;
    }
  | {
      type: QueryStateActions.CHANGE_SORT_PARAMS;
      payload: {
        sort_by: string;
        direction: "asc" | "desc";
      };
    }
  | {
      type: QueryStateActions.CHANGE_SEARCH_QUERY;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_FROM_DATE;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_TO_DATE;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_PAGE;
      payload: number;
    }
  | {
      type: QueryStateActions.CHANGE_PRACTICE_ID;
      payload: string;
    }| {
      type: QueryStateActions.CHANGE_GLOBAL_DOCTOR_ID;
      payload: string;
    }| {
      type: QueryStateActions.SET_FILTERS;
      payload: Partial<QueryParamsState>;
    }| {
      type: QueryStateActions.CLEAR_STATE;
      payload: Partial<QueryParamsState>;
    };

export type DownloadZipResponseType = {
  response: string;
  code: number;
  message: string;
  report_name: string;
};

export type DownloadZipErrorType = {
  code: number;
  error: string;
};
